import { StatusBadge } from '@/components/StatusBadge'
import type { RequirementsSpecificationSummary } from '@/types/requirements_specification'

interface Props {
  rd: RequirementsSpecificationSummary | null
}

export function SpecBadge ({ rd }: Props): React.ReactElement | null {
  if (rd == null) return null
  if (rd.status === 'risk_checked') {
    return <StatusBadge variant='checked' label='チェック済み' />
  }
  if (['queued', 'running'].includes(rd.pipeline_status) ||
      ['queued', 'running'].includes(rd.audit_pipeline_status)) {
    return <StatusBadge variant='running' label='解析中' />
  }
  if (rd.pipeline_status === 'succeeded') {
    return <StatusBadge variant='editing' label='編集中' />
  }
  return null
}
